// export this package's api
import Upload from './Upload';

export default Upload;


//////////////////
// WEBPACK FOOTER
// /Users/shuai/Documents/github/ant-design-pro-site/scaffold/node_modules/_rc-upload@2.6.3@rc-upload/es/index.js
// module id = null
// module chunks = 